// import { useState } from "react"
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // Checkbox,
  // Button,
  Paper,
  Box,
  Typography,
} from "@mui/material"
import EditIcon from "../../../icons/harmonization/EditIcon"
import ViewIcon from "../../../icons/harmonization/ViewIcon"
import IconButton from "../../../components/IconButton"
import { useNavigate } from "react-router-dom"
import { SCREENS_DETAILS } from "../../../util/StaticData"
import { useAppDispatch, useAppSelector } from "../../../util/hooks"
import { setActiveTab, setInsightsData } from "../mapping/MapSlice"
import { useEffect } from "react"

interface ISummaryData {
  name: string
  rows: number
  volume_uc: number
  status: number
  percentage: number
  approval_completion: number
}

const sampleSummary: ISummaryData[] = [
  {
    name: "Absolute Mapped",
    rows: 230,
    percentage: 0,
    volume_uc: 2500,
    status: 1,
    approval_completion: 100,
  },
  {
    name: "Approximate Mapped",
    rows: 160,
    percentage: 0,
    volume_uc: 1600,
    status: 3,
    approval_completion: 60,
  },
  {
    name: "Not Mapped",
    rows: 30,
    percentage: 0,
    volume_uc: 1000,
    status: 2,
    approval_completion: 0,
  },
]

const getBackgroundStatusColor = (status: ISummaryData["status"]) => {
  switch (status) {
    case 1:
      return "status.green"
    case 2:
      return "status.neutral"
    case 3:
      return "status.yellow"
    default:
      return "status.red"
  }
}

const getStatusTextColor = (status: ISummaryData["status"]) => {
  if (status === 2) {
    return "textColors.grey2"
  } else return "white"
}

export const removeRedundancy = (data: any) => {
  const uniqueData = [...new Set(data)]

  return uniqueData
}

const SummaryTable = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { mappedData } = useAppSelector((state) => state.map)
  console.log("[SummaryTable] mappedData length:", mappedData?.length)
  if (mappedData && mappedData.length) {
    console.log("[SummaryTable] first row:", mappedData[0])
  }

  // const absoluteMappedVol = mappedData.reduce(
  //   (total, data) =>
  //     parseInt(data.mapping_accuracy.replace("%", "")) >= 90
  //       ? total + data.vol_l
  //       : total,
  //   0,
  // )
  // const approximateMappedVol = mappedData.reduce(
  //   (total, data) =>
  //     parseInt(data.mapping_accuracy.replace("%", "")) >= 80 &&
  //     parseInt(data.mapping_accuracy.replace("%", "")) < 90
  //       ? total + data.vol_l
  //       : total,
  //   0,
  // )
  // const notMappedVol = mappedData.reduce(
  //   (total, data) =>
  //     parseInt(data.mapping_accuracy.replace("%", "")) < 80
  //       ? total + data.vol_l
  //       : total,
  //   0,
  // )

  const absoluteMapped = (mappedData as any[]).filter(
    (d) => (d?.similarity ?? 0) >= 0.9,
  )

  const notMapped = (mappedData as any[]).filter(
    (d) => (d?.similarity ?? 0) < 0.8,
  )

  const approximateMapped = (mappedData as any[]).filter(
    (d) => (d?.similarity ?? 0) >= 0.8 && (d?.similarity ?? 0) < 0.9,
  )
  console.log("[SummaryTable] counts:", {
    absolute: absoluteMapped.length,
    approximate: approximateMapped.length,
    notMapped: notMapped.length,
  })

  useEffect(() => {
    dispatch(setInsightsData())
  }, [mappedData.length])

  const absoluteMappedLength = absoluteMapped.length
  const absoluteApprovalCompleted = absoluteMapped.filter(
    (data) => data.status === 1,
  ).length

  const approximateMappedLength = approximateMapped.length

  const approximateApprovalCompleted = approximateMapped.filter(
    (data) => data.status === 1,
  ).length

  const notMappedLength = notMapped.length
  const notMappedApprovalCompleted = notMapped.filter(
    (data) => data.status === 1,
  ).length

  const getStatus = (status: ISummaryData["status"]) => {
    switch (status) {
      case 1:
        return "Approved"
      case 2:
        return "Yet to Approve"
      case 3:
        return "Partially Approved"
      default:
        return ""
    }
  }

  const handleViewResults = (tab: string) => {
    dispatch(setActiveTab(tab))
    navigate(SCREENS_DETAILS.MAPPING_INSIGHTS)
  }

  return (
    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table
        sx={{ "& th, td": { fontSize: "13px", border: "none", py: 1 } }}
        aria-label="summary table"
      >
        <TableHead>
          <TableRow sx={{ backgroundColor: "tableColors.header" }}>
            <TableCell></TableCell>
            <TableCell align="left" sx={{ fontWeight: 700 }}>
              Rows
            </TableCell>
            <TableCell align="center" sx={{ fontWeight: 700 }}>
              Percentages
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Approval Completion</TableCell>
            <TableCell align="left" sx={{ fontWeight: 700 }}>
              Status
            </TableCell>
            <TableCell align="left" sx={{ fontWeight: 700 }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {sampleSummary.map((row, index) => (
            <TableRow
              key={index + row.name}
              sx={{ backgroundColor: "tableColors.body" }}
            >
              <TableCell
                sx={{ fontWeight: 700, backgroundColor: "tableColors.header" }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <p>{row.name}</p>
                </Box>
              </TableCell>

              <TableCell align="left">
                {Math.floor(
                  index === 0
                    ? absoluteMappedLength
                    : index === 1
                    ? approximateMappedLength
                    : notMappedLength,
                )}
              </TableCell>

              <TableCell align="center">
                <p>
                  {mappedData.length > 0
                    ? Math.floor(
                        index === 0
                          ? (absoluteMappedLength / mappedData.length) * 100
                          : index === 1
                          ? (approximateMappedLength / mappedData.length) *
                            100
                          : (notMappedLength / mappedData.length) * 100,
                      )
                    : 0}
                  %
                </p>
              </TableCell>

              <TableCell align="center">
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography
                    sx={{
                      backgroundColor: "backgrounds.50",
                      color: "textColors.grey2",
                      width: "fit-content",
                      px: 1,
                      fontSize: 13,
                    }}
                  >
                    {Math.floor(
                      index === 0
                        ? absoluteMappedLength
                          ? (absoluteApprovalCompleted / absoluteMappedLength) *
                            100
                          : 0
                        : index === 1
                        ? approximateMappedLength
                          ? (approximateApprovalCompleted /
                              approximateMappedLength) *
                            100
                          : 0
                        : notMappedLength
                        ? (notMappedApprovalCompleted / notMappedLength) * 100
                        : 0,
                    )}
                    %
                  </Typography>
                </Box>
              </TableCell>
              <TableCell align="left">
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      backgroundColor:
                        approximateApprovalCompleted === 0 && index === 1
                          ? getBackgroundStatusColor(2)
                          : getBackgroundStatusColor(row.status),
                      color:
                        approximateApprovalCompleted === 0 && index === 1
                          ? getStatusTextColor(2)
                          : getStatusTextColor(row.status),
                      fontSize: 13,
                      py: "2px",
                      px: 1,
                      width: "fit-content",
                    }}
                  >
                    {approximateApprovalCompleted === 0 && index === 1
                      ? getStatus(2)
                      : getStatus(row.status)}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell align="left">
                <Box className="flex">
                  <IconButton
                    Icon={ViewIcon}
                    onClick={() => handleViewResults(row.name)}
                    ariaLabel="View"
                  />
                  <IconButton
                    Icon={EditIcon}
                    onClick={() => handleViewResults(row.name)}
                    ariaLabel="View"
                  />
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SummaryTable
